import { GridLoader } from "react-spinners"

const Loader = () => {
  return (
    <div className='loader'><GridLoader color="#8e5d8f" /></div>
  )
}

export default Loader